import { render, staticRenderFns } from "./ProformaEditor.vue?vue&type=template&id=c2b5e78a&"
import script from "./ProformaEditor.vue?vue&type=script&lang=js&"
export * from "./ProformaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports